import { useBroadcastStore } from '../../../store/broadcast';
import { TelegramPostPreview } from '../../common/TelegramPostPreview/TelegramPostPreview';
import styles from './BroadcastPreview.module.scss';
import { FlexRow, Panel, Text } from '@epam/promo';

export const BroadcastPreview = () => {
  const { draft } = useBroadcastStore((state) => state);

  return (
    <Panel shadow cx={styles.wrapper}>
      <FlexRow cx={styles.header} padding="12">
        <Text color="gray90" fontSize="18" fontWeight="600">
          Preview
        </Text>
      </FlexRow>
      <TelegramPostPreview
        attachments={draft.attachments}
        message={draft.message}
        title={draft.title}></TelegramPostPreview>
    </Panel>
  );
};
